// extracted by mini-css-extract-plugin
export default {"container":"RelatedConcepts__container___GlWMM","list":"RelatedConcepts__list___UxYNb"};